import * as R from 'ramda'

export const shouldShowAccountDetail = listAccountDetail =>
  !R.all(
    R.equals(false),
    R.map(R.either(R.isNil, R.isEmpty))(listAccountDetail)
  )



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/RegisterRace/utils.js